import { Component } from '@angular/core';
import { AppComponent } from './../app.component';
import { HttpClient } from '@angular/common/http';
import { BrowserService } from '../service/browser.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-tab1',
  templateUrl: 'tab1.page.html',
  styleUrls: ['tab1.page.scss']
})
export class Tab1Page {

  table_head = []
  table_data = []
  meta = []
  dashboard: any;
    
  constructor(
    private http: HttpClient,
    private browser: BrowserService,
    private sanitise: DomSanitizer
  ) {}

  ngOnInit() {
    // this.fetchUpdates();
    this.dashboard = this.sanitise.bypassSecurityTrustResourceUrl("<div class='tableauPlaceholder' id='viz1597597738397' style='position: relative'><noscript><a href='#'><img alt=' ' src='https:&#47;&#47;public.tableau.com&#47;static&#47;images&#47;TB&#47;TB_15970643590730&#47;Dashboard1&#47;1_rss.png' style='border: none' /></a></noscript><object class='tableauViz'  style='display:none;'><param name='host_url' value='https%3A%2F%2Fpublic.tableau.com%2F' /> <param name='embed_code_version' value='3' /> <param name='site_root' value='' /><param name='name' value='TB_15970643590730&#47;Dashboard1' /><param name='tabs' value='no' /><param name='toolbar' value='yes' /><param name='static_image' value='https:&#47;&#47;public.tableau.com&#47;static&#47;images&#47;TB&#47;TB_15970643590730&#47;Dashboard1&#47;1.png' /> <param name='animate_transition' value='yes' /><param name='display_static_image' value='yes' /><param name='display_spinner' value='yes' /><param name='display_overlay' value='yes' /><param name='display_count' value='yes' /><param name='language' value='en' /></object></div>                <script type='text/javascript'>                    var divElement = document.getElementById('viz1597597738397');                    var vizElement = divElement.getElementsByTagName('object')[0];                    if ( divElement.offsetWidth > 800 ) { vizElement.style.width='1000px';vizElement.style.height='827px';} else if ( divElement.offsetWidth > 500 ) { vizElement.style.width='1000px';vizElement.style.height='827px';} else { vizElement.style.width='100%';vizElement.style.height='1327px';}                     var scriptElement = document.createElement('script');                    scriptElement.src = 'https://public.tableau.com/javascripts/api/viz_v1.js';                    vizElement.parentNode.insertBefore(scriptElement, vizElement);                </script>");
  }

  public AppRef = AppComponent;

  setLang() {
    if (AppComponent.languageToggle) {
      AppComponent.currentLang = 'english';
    } else {
      AppComponent.currentLang = 'hindi';
    }
  }
  
  fetchUpdates() {
    this.http.get(AppComponent.base + 'india_data').subscribe((res) => {
        if (res['status']) {
          this.table_head = res['data']['table'][0]
          this.table_data = res['data']['table'][1]
          this.meta = res['data']['meta']
        }
      }, (err) => {
    });
  }

  loadLink(link) {
    this.browser.openLink(link);
  }
}
